import React from 'react';

import type { ModalProps } from 'antd';
import { Modal as AntdModal } from 'antd';

export type { ModalFuncProps, ModalProps } from 'antd';

function ModalComponent({ ...props }: ModalProps) {
  return (
    <AntdModal
      classNames={{
        container: 'container',
        footer: 'footer',
      }}
      {...props}
    />
  );
}

export const Modal = Object.assign(
  ModalComponent,
  AntdModal
) as typeof AntdModal;

export default Modal;
